package one.healthium.onboarding.di

import one.healthium.onboarding.ui.user_binding.UserViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val onboardingCommonModule = module {
    viewModelOf(::UserViewModel)
}